namespace advisorop.components.servicer {

    export class AoAccNotInOrionMonitorController {
        dgData: Array<any>;
        advisoryFirmId: number;
        pageLen: number;
        issuesCount: number;
        dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;

        dgInst: DevExpress.ui.dxDataGrid;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#aoAccNotInOrionMonitorContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "generalService", "advisoryFirmApi"];
        constructor(
            private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "AoAccNotInOrionMonitor"
                },
                bindingOptions: {
                    dataSource: "vm.dgData",
                },
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    pageSize: this.pageLen,
                    enabled: true
                },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "accountNumber", caption: "Account Number", width: 140 },
                    { dataField: "accountName", caption: "Account Name", width: 300 },
                    { dataField: "advisorNames", caption: "Advisor", width: 200 },
                    { dataField: "accountTypeDescription", caption: "Account Type", width: 180 },
                    { dataField: "orionStatus", caption: "Orion Status", width: 120 },
                    { dataField: "accountId", caption: "AdvisorOp Id", visible: false, showInColumnChooser: true },
                    { dataField: "orionAccountId", caption: "Orion Id", visible: false, showInColumnChooser: true },
                ],
                onExporting: (e: any) => {
                    // Temporarily show hidden ID columns so they are included in the Excel export
                    const grid = e.component as DevExpress.ui.dxDataGrid;
                    const hiddenFields = ["accountId", "orionAccountId"];
                    hiddenFields.forEach(f => grid.columnOption(f, "visible", true));
                },
                onExported: (e: any) => {
                    const grid = e.component as DevExpress.ui.dxDataGrid;
                    const hiddenFields = ["accountId", "orionAccountId"];
                    hiddenFields.forEach(f => grid.columnOption(f, "visible", false));
                },
            };
        }

        loadDgData() {
            this.isInitializing = true;
            this.issuesCount = 0;

            if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                this.servicerService.getAoAccountsNotInOrionData(this.advisoryFirmId)
                    .then(response => {
                        this.dgData = response.data;
                        if (this.dgData.length > 0) {
                            this.issuesCount = this.dgData.length;
                        }
                        this.isInitializing = false;
                    }, err => this.isInitializing = false)
                    .catch(err => {
                        this.generalService.showError(err);
                    });
            }
        };

        firmChanged(): void {
            this.advisoryFirmId = this.selFirm.id;
            this.loadDgData();
        }

        $onInit(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }

        $onChanges(evt) {
        };
    }


    class AoAccNotInOrionMonitor implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<",
                pageLen: "<",
                issuesCount: "="
            };
            this.controller = AoAccNotInOrionMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/ao-acc-not-in-orion-monitor.html";
        }
    }
    angular.module(Constants.APP).component("aoAccNotInOrionMonitor", new AoAccNotInOrionMonitor());

}
